import { SolutionRuleConfigurationPreferences } from '../types';

export const RULE_TIME_UNITS = [
  { value: '5', label: '5 Minutes' },
  { value: '10', label: '10 Minutes' },
  { value: '15', label: '15 Minutes' },
  { value: '20', label: '20 Minutes' },
  { value: '30', label: '30 Minutes' },
  { value: '60', label: '1 Hour' },
];

export const RULE_NOTIFICATION_PREFERENCE_OPTIONS = [
  {
    value: SolutionRuleConfigurationPreferences.Email,
    label: 'Email',
  },
  {
    value: SolutionRuleConfigurationPreferences.SMS,
    label: 'SMS',
  },
  {
    value: SolutionRuleConfigurationPreferences.TargetUrl,
    label: 'Target Url',
  },
];
